<script>
import AnnouncementsApi from "@/services/announcements-api";

export default {
  props: {
    propWhiteBackground: { type: Boolean, default: true },
    propFullwidth: { type: Boolean, default: false },
  },
  data() {
    return {
      highlightsList: [],
    };
  },
  mounted() {
    this.getHighlights();
  },
  methods: {
    async getHighlights() {
      try {
        const result = await AnnouncementsApi.getHighlights(1, 100);
        if (result) this.highlightsList = result.list;
      } catch (error) {
        console.error("Error fetching highlights:", error);
      }
    },
    padIndex(i) {
      return String(i + 1).padStart(2, '0');
    },
  },
};
</script>


<template>
  <div class="mss-tf-section py-5" v-if="highlightsList.length">
    <div :class="propFullwidth ? 'px-4' : 'home-page-80-width'" class="px-3 px-lg-0">

      <!-- Section Header -->
      <div class="mss-section-header mb-5">
        <h2 class="mss-section-title">Temps Forts</h2>
        <div class="mss-section-line"></div>
        <p class="mss-section-sub mt-3">Restez informés de nos rendez-vous professionnels et moments clés.</p>
      </div>

      <!-- Two-column agenda grid -->
      <div class="row">
        <div
          v-for="(item, i) in highlightsList"
          :key="item.id"
          class="col-12 col-lg-6 mb-4 px-lg-3"
        >
          <div class="mss-tf-card">

            <!-- Image panel -->
            <div class="mss-tf-img-panel">
              <img :src="'/api/image/get/' + item.image" class="mss-tf-img" alt="" />
              <!-- Sequential number -->
              <div class="mss-tf-number">{{ padIndex(i) }}</div>
            </div>

            <!-- Content panel -->
            <div class="mss-tf-body">
              <span class="mss-tf-date">
                <i class="bx bx-calendar mr-1"></i>{{ item.date }}
              </span>
              <h5 class="mss-tf-title mt-2">{{ item.title }}</h5>
              <p class="mss-tf-desc mt-2" v-html="item.description"></p>
            </div>

            <!-- Blue left accent bar -->
            <div class="mss-tf-accent"></div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<style scoped>
.mss-tf-section {
  background: #f8fafd;
}

/* Section header */
.mss-section-title {
  font-size: 1.65rem;
  font-weight: 800;
  color: #1853ba;
  margin-bottom: 6px;
}
.mss-section-line {
  width: 40px;
  height: 3px;
  background: #8ac727;
  border-radius: 2px;
}
.mss-section-sub {
  color: #8898aa;
  font-size: 14px;
  margin-bottom: 0;
}

/* ── Agenda card ── */
.mss-tf-card {
  display: flex;
  align-items: stretch;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e8eef8;
  box-shadow: 0 2px 12px rgba(24, 83, 186, 0.05);
  position: relative;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  height: 100%;
}
.mss-tf-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 36px rgba(24, 83, 186, 0.12);
}

/* Left accent bar (hidden by default, slides in on hover) */
.mss-tf-accent {
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #1853ba, #8ac727);
  border-radius: 14px 0 0 14px;
  opacity: 0;
  transition: opacity 0.25s ease;
}
.mss-tf-card:hover .mss-tf-accent {
  opacity: 1;
}

/* Image panel — fixed width, fills height */
.mss-tf-img-panel {
  width: 160px;
  min-width: 160px;
  min-height: 160px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}
.mss-tf-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}
.mss-tf-card:hover .mss-tf-img {
  transform: scale(1.07);
}

/* Sequential number badge */
.mss-tf-number {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 2rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.90);
  line-height: 1;
  text-shadow: 0 2px 8px rgba(0,0,0,0.4);
  letter-spacing: -1px;
  z-index: 2;
}

/* Content panel */
.mss-tf-body {
  padding: 24px 24px 24px 22px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  gap: 6px;
}

.mss-tf-date {
  font-size: 12px;
  font-weight: 700;
  color: #8ac727;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.mss-tf-title {
  font-size: 16px;
  font-weight: 800;
  color: #1a2340;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mss-tf-desc {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.7;
  margin: 0;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 991px) {
  .mss-tf-section .home-page-80-width {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
@media (max-width: 575px) {
  .mss-tf-img-panel { width: 100px; min-width: 100px; min-height: 130px; }
  .mss-tf-number { font-size: 1.5rem; }
  .mss-tf-body { padding: 14px; }
  .mss-tf-desc { -webkit-line-clamp: 3; }
  .mss-tf-title { font-size: 14px; }
}
</style>
